import React from "react";
import { observer, inject, Provider } from "mobx-react";
import ServicePlanStore from "./ServicePlanStore";
import ServicePlanModelSelector from "./components/ServicePlanModelSelector";
import ServicePlanPriceTable from "./components/ServicePlanPriceTable";
import ServicePlanPriceGuide from "./components/ServicePlanPriceGuide";
import Loader from "../Loader";

interface ServicePlanProps {}

interface InjectedProps extends ServicePlanProps {
  servicePlanStore: ServicePlanStore;
}

interface ServicePlanState {
  isContentExist: boolean;
}

@inject("servicePlanStore")
@observer
class servicePlan extends React.Component<ServicePlanProps, ServicePlanState> {
  constructor(props: ServicePlanProps) {
    super(props);
    this.state = {
      isContentExist: false,
    };
  }

  get injected() {
    return this.props as InjectedProps;
  }

  componentDidMount(): void {
    const { servicePlanStore } = this.injected;
    servicePlanStore.fetchServicePlanContentData();

    this.setState({
      isContentExist:
        servicePlanStore.servicePlanCMSModel.response.length > 0 ||
        (servicePlanStore.cpsTabs?.length ?? 0) > 0,
    });

    servicePlanStore.fetchServicePlanData();
    window["pushDigitalData"]({
      event: "_pageLoaded",
    });
  }

  handleModelChange = (target, model) => {
    target.preventDefault();

    const { servicePlanStore } = this.injected;
    servicePlanStore.setModelVariantSelected("");
    servicePlanStore.setServicePlanSelectedModel(model.modelID);
    servicePlanStore.CalculateServicePlanTotalPrice(model);
  };

  handleTabChange = (tab) => {
    const { servicePlanStore } = this.injected;
    servicePlanStore.setModelVariantSelected("");
    servicePlanStore.setSelectedTabId(tab.tabId);
    // Keep selectedModel in sync for the legacy API data fetching
    if (tab.modelId) {
      servicePlanStore.setServicePlanSelectedModel(tab.modelId);
      servicePlanStore.CalculateServicePlanTotalPrice({
        modelID: tab.modelId,
        name: tab.tabName || ""
      });
    }
  };

  handleModelVariantChange = (target) => {
    target.preventDefault();
    const { servicePlanStore } = this.injected;
    servicePlanStore.setModelVariantSelected(target.currentTarget.text);
  };

  render() {
    const { servicePlanStore } = this.injected;

    // Use computed getters for proper MobX tracking
    const servicePlanResponse = servicePlanStore.servicePlanResponse;
    const servicePlanIsContentExist = servicePlanStore.servicePlanIsContentExist;
    const servicePlanIsRequestError = servicePlanStore.servicePlanIsRequestError;

    return (
      this.state.isContentExist && (
        <div className="container">
          <p></p>
          <div className="cappedPricingTableHeading">
            <h4>Subaru Service Plan Price Guide</h4>
            <p>
              If you are looking to buy a new Subaru, please select the model
              you are interested in to view total 3 or 5 Year Service Plan
              costs.
            </p>
          </div>
          <div className="capped-pricing-desktop">
            {this.state.isContentExist ? (
              <ServicePlanModelSelector
                vehicleModels={servicePlanStore.servicePlanCMSModel.response}
                handleModelChange={(e, model) => {
                  this.handleModelChange(e, model);
                }}
                selectedModel={servicePlanStore.servicePlanSelectedModel}
                cpsTabs={servicePlanStore.cpsTabs}
                selectedTabId={servicePlanStore.selectedTabId}
                onTabChange={(tab) => this.handleTabChange(tab)}
              />
            ) : (
              <p>Vehicle models are not configured for ServicePlan tool.</p>
            )}

            {this.state.isContentExist &&
            servicePlanResponse.length > 0 ? (
              <ServicePlanPriceTable
                selectedModel={servicePlanStore.servicePlanSelectedModel}
                isServicePlan={true}
                handleModelVariantChange={(e) => {
                  this.handleModelVariantChange(e);
                }}
              />
            ) : servicePlanIsRequestError ? (
              <p className="text-center">
                An error occurred while loading pricing data. Please try again
                later.
              </p>
            ) : servicePlanIsContentExist ? (
              <p className="text-center">
                Pricing is not available for this model.
              </p>
            ) : (
              <Loader isLoading={true} isPositionRelative={false} />
            )}
          </div>
          <div className="capped-pricing-mobile">
            {servicePlanResponse.length > 0 ? (
              <ServicePlanPriceGuide
                isServicePlan={true}
                onSelectedModelChange={(model) => {
                  servicePlanStore.setModelVariantSelected("");
                  servicePlanStore.setServicePlanSelectedModel(model.modelID);
                  servicePlanStore.CalculateServicePlanTotalPrice(model);
                }}
                selectedModel={servicePlanStore.servicePlanSelectedModel}
                vehicleModelsListForSelectControl={
                  servicePlanStore.vehicleModelsListForSelectControlServicePlan
                }
                vehicleModelDataList={servicePlanResponse}
                cmsContent={servicePlanStore.servicePlanCMSModel.response}
                showTotals={true}
                selectedModelVariant={servicePlanStore.modelVariantsSelected}
                handleModelVariantChange={(e) => {
                  this.handleModelVariantChange(e);
                }}
                cpsTabs={servicePlanStore.cpsTabs}
                selectedTabId={servicePlanStore.selectedTabId}
                onTabChange={(tab) => this.handleTabChange(tab)}
              />
            ) : servicePlanIsRequestError ? (
              <p className="text-center">
                An error occurred while loading pricing data. Please try again
                later.
              </p>
            ) : servicePlanIsContentExist ? (
              <p className="text-center">
                Pricing is not available for this model.
              </p>
            ) : (
              <Loader isLoading={true} isPositionRelative={false} />
            )}
          </div>
        </div>
      )
    );
  }
}

export default servicePlan;

